<template>
    <div>
        <div class="tit">预测明细</div>
        
        <el-form inline>
            <el-form-item>
                <el-input v-model="form.number" placeholder="请输入期数" 
				clearable 
				></el-input>
            </el-form-item>
            <el-form-item>
                <el-select v-model="form.preType" placeholder="请选择彩种" clearable>
                    <el-option v-for="(item,index) in lotteryType" :key="index" :label="item.dictLabel"
                               :value="item.dictValue"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-date-picker
                    v-model="time"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" @click="getList">搜索</el-button>
            </el-form-item>
        </el-form>
        
        <el-table
            v-loading="tableLoading"
            :data="list"
            :header-cell-style="{'text-align':'center'}"
            :cell-style="{'text-align':'center'}"
        
        >
            <!-- <el-table-column type="index" label="序号"></el-table-column> -->
            <el-table-column prop="preTypeName" label="彩种">
            </el-table-column>
            <el-table-column prop="number" label="期数"></el-table-column>
            <el-table-column prop="createTime" label="预测时间" width="300"></el-table-column>
            <el-table-column prop="preIndexTypeName" label="预测指标类型">
            </el-table-column>
            <!-- <el-table-column prop="isForcasted" label="对与错"></el-table-column> -->
            <el-table-column prop="score" label="得分"></el-table-column>
            <!-- <el-table-column prop="" label="操作"></el-table-column> -->
        </el-table>
        
        <el-pagination v-if="listPagin.total > 9"
                       style="padding-top:20px;text-align:right"
                       background
                       layout="prev, pager, next"
                       @current-change="changePage"
                       :page-size="listPagin.limit"
                       :total="listPagin.total">
        </el-pagination>
    </div>
</template>

<script>
import {yucemingxi_detailList} from "@/api/personalCenter"
import {queryLotteryType} from "@/api/common";

export default {
    data() {
        return {
            time: [],
            list: [],
            
            lotteryType: [],
            
            form: {
                number: '',
                preType: '',
            },
            
            tableLoading: true,
            listPagin: {
                page: 1,
                limit: 10,
                total: 0
            },
        }
    },
    mounted() {
        this.getList()
        
        queryLotteryType().then(res => {
            this.lotteryType = JSON.parse(JSON.stringify(res.data, ['dictLabel', 'dictValue']))
        })
    },
    methods: {
        getList() {
			let time = this.time

            yucemingxi_detailList({
                pageNum: this.listPagin.page,
                pageSize: this.listPagin.limit,
                startDate: time ? time[0] :'',
                endDate: time ? time[1] :'',
                number: this.form.number,
                preType: this.form.preType,
            }).then(res => {
                this.tableLoading = false
                this.list = res.rows
                
                this.listPagin.total = res.total
            })
        },
        // 分页状态变化
        changePage(e) {
            this.tableLoading = true
            this.listPagin.page = e
            this.getList();
        },
    }
}
</script>

<style lang="scss" scoped>
.tit {
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 20px;
}

.shaixuan {
    background-color: #dbdbdb;
    padding: 10px;
    display: flex;
    
    span {
        margin: 0 20px;
    }
    
    input {
        background-color: #ffffff;
    }
    
}

.grid {
    margin-top: 20px;
    text-align: center;
    
    > div {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        
        span {
            border: 1px solid rgba(0, 0, 0, 0.1);
            display: inline-block;
            padding: 10px 0;
        }
    }
}
</style>